import { type FormItemProps, Input, type InputProps } from 'antd';
import { useField } from 'formik';
import { memo } from 'react';
import styled from 'styled-components';
import FormItem from './FormItem';

export interface InputFieldProps extends Omit<InputProps, 'value' | 'onChange' | 'autoComplete'> {
    name: string;
    label?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
}

const StyledInput = styled(Input)`
    border-bottom: 1px line;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    box-shadow: none;
    font-size: 16px;

    &.ant-input:focus,
    .ant-input-focused {
        border-color: none;
        box-shadow: none;
    }

    & .ant-form-label {
        margin-bottom: 0;
    }
`;

const InputField = ({ name, required, label, itemProps, ...props }: InputFieldProps) => {
    const [field, meta] = useField({ name });

    return (
        <FormItem {...itemProps} label={label} meta={meta} required={required}>
            <StyledInput
                autoComplete="off"
                // spread props
                {...props}
                // then spread the field properties itself
                {...field}
            />
        </FormItem>
    );
};

export default memo(InputField);
